import { DEVICE_SCOPE, APP_DEVICE_SCOPE, WX_APP_PERMISSION_CHECK_RESULT } from '../constants';
import { NAME } from '../constants';

// -----------------检测类型工具函数-----------------
/**
 * 检测input类型是否为string
 * @param {*} input 任意类型的输入
 * @returns {Boolean} true->string / false->not a string
 */
export const isString = function(input) {
  return typeof input === NAME.STRING;
};

export const isObject = function(input) {
  return input !== null && typeof input === NAME.OBJECT;
};

/**
 * 检测input类型是否为数组
 * @param {*} input 任意类型的输入
 * @returns {Boolean} true->array / false->not an array
 */
export const isArray = function(input) {
  if (typeof Array.isArray === NAME.FUNCTION) {
    return Array.isArray(input);
  }
  return getType(input) === NAME.ARRAY;
};
/**
 * Checks to see if a value is undefined
 * @param {*} input 任意类型的输入
 * @returns {Boolean} true->input value is undefined
 */
export const isUndefined = function(input) {
  return typeof input === NAME.UNDEFINED;
};
/**
 * 检测input类型是否为数组或者object
 * @param {*} input 任意类型的输入
 * @returns {Boolean} true->input is an array or an object
 */
export const isArrayOrObject = function(input) {
  return isArray(input) || isObject(input);
};
/**
 * 检测input类型是否为function
 * @param {*} input 任意类型的输入
 * @returns {Boolean} true->input is a function
 */
export const isFunction = function(input) {
  return typeof input === NAME.FUNCTION;
};
/**
 * 检测input是否为Error的实例
 * @param {*} input 任意类型的输入
 * @returns {Boolean} true->input is an instance of Error
 */
export const isInstanceOfError = function(input) {
  return input instanceof Error;
};
/**
 * Get the object type string
 * @param {*} input 任意类型的输入
 * @returns {String} the object type string
 */
export const getType = function(input) {
  return Object.prototype.toString
    .call(input)
    .match(/^\[object (.*)\]$/)[1]
    .toLowerCase();
};

// -----------------获取时间工具函数，计算耗时用-----------------
let baseTime = 0;
if (!Date.now) {
  Date.now = function now() {
    return new Date().getTime();
  };
}

// export const TimeUtil = {
//   now() {
//     if (baseTime === 0) {
//       baseTime = Date.now() - 1;
//     }

//     const diff = Date.now() - baseTime;
//     if (diff > 0xffffffff) {
//       baseTime += 0xffffffff;
//       return Date.now() - baseTime;
//     }
//     return diff;
//   },

//   utc() {
//     return Math.round(Date.now() / 1000);
//   },
// };
/**
 * 序列化Error实例，只序列化Error实例的message和code属性（如果有的话）
 * @param {Error} error Error实例
 * @returns {String} 序列化后的内容
 */
export const stringifyError = function(error) {
  return JSON.stringify(error, ['message', 'code']);
};
// 获取value的类型
export function getValueType(value) {
  return Reflect.apply(Object.prototype.toString, value, [])
    .replace(/^\[object\s(\w+)\]$/, '$1')
    .toLowerCase();
}
export function safelyParse(data) {
  if (typeof data !== 'string') {
    return data;
  }
  let result;
  try {
    const tempData = JSON.parse(data);
    if (typeof tempData === 'object' && tempData) {
      result = tempData;
    } else {
      result = data;
    }
  } catch (error) {
    result = data;
  }
  return result;
}

export function generateRandomString(length) {
  length = length || 32;
  const seed = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  let result = '';

  for (let i = 0; i < length; i++) {
    result += seed.charAt(Math.floor(Math.random() * (seed.length)));
  }

  return result;
}
// 兼容小程序插件环境
function getAuthSetting() {
  return new Promise(async (resolve, reject) => {
    wx.getSetting({
      success: (res) => {
        let authSetting = null;
        if (!wx.$TUICallKitPlugin) {
          authSetting = res.authSetting;
        } else {
          authSetting = res.miniprogramAuthSetting;
        }
        resolve(authSetting);
      },
      fail: (error) => {
        reject(error);
      },
    });
  });
}
/**
 * 获取设备权限，查看当前是否有麦克风以及摄像头权限
 * @param {Object} params - 参数对象
 * @param {Boolean} params.microphone 麦克风权限
 * @param {Boolean} params.camera     摄像头权限
 */
export async function deviceCheck(params) {
  if (!params) return false;
  const { microphone = false, camera = false } = params;
  try {
    const authSetting = await getAuthSetting() || false;
    const isMicrophone = authSetting[DEVICE_SCOPE.RECORD];
    const isCamera = authSetting[DEVICE_SCOPE.CAMERA];
    // 同时检查麦克风和摄像头权限
    if (microphone && camera) {
      return isMicrophone && isCamera;
    }
    // 只检查麦克风权限
    if (microphone) {
      return isMicrophone;
    }
    // 只检查摄像头权限
    if (camera) {
      return isCamera;
    }
    return false;
  } catch (error) {
    return false;
  }
}
// 获取微信 App 权限，是否有麦克风以及摄像头权限
export function appDeviceCheck(params) {
  if (!params) return false;
  const { microphone = false, camera = false } = params;
  const appAuthorizeSetting = wx.getAppAuthorizeSetting();
  const microphoneAuthorized = appAuthorizeSetting[APP_DEVICE_SCOPE.MICROPHONE_AUTHORIZED] === WX_APP_PERMISSION_CHECK_RESULT.AUTHORIZED;
  const cameraAuthorized = appAuthorizeSetting[APP_DEVICE_SCOPE.CAMERA_AUTHORIZED] === WX_APP_PERMISSION_CHECK_RESULT.AUTHORIZED;
  // 同时检查麦克风和摄像头权限
  if (microphone && camera) {
    return microphoneAuthorized && cameraAuthorized;
  }
  // 只检查麦克风权限
  if (microphone) {
    return microphoneAuthorized;
  }
  // 只检查摄像头权限
  if (camera) {
    return cameraAuthorized;
  }
  return false;
}
// callkit 的 offlinePushInfo 转成 c++ 解析的字段
export function convertOfflinePushInfoToCIdentifier (offlinePushInfo = {}) {
  let obj = {
    title: offlinePushInfo.title,
    desc: offlinePushInfo.description || '',
    extension: offlinePushInfo.extension || '',
    is_disable_push: offlinePushInfo.isDisablePush || false,
    ios_push_type: offlinePushInfo.iOSPushType || 0, // 默认 “普通推送”, 1-"voip 推送"
    android_push_type: offlinePushInfo.androidPushType || 0, // 默认 notification, 1-data
    ignore_ios_badge: !!offlinePushInfo.ignoreIOSBadge,
    android_vivo_classification: offlinePushInfo.androidVIVOClassification, // 已废弃
  };
  if (offlinePushInfo.iOSSound) {
    obj.ios_sound = offlinePushInfo.iOSSound;
  }
  if (offlinePushInfo.androidSound) {
    obj.android_sound = offlinePushInfo.androidSound;
  }
  if (offlinePushInfo.androidOPPOChannelID) {
    obj.android_oppo_channel_id = offlinePushInfo.androidOPPOChannelID;
  }
  if (offlinePushInfo.androidFCMChannelID) {
    obj.android_fcm_channel_id = offlinePushInfo.androidFCMChannelID;
  }
  if (offlinePushInfo.androidXiaoMiChannelID) {
    obj.android_xiaomi_channel_id = offlinePushInfo.androidXiaoMiChannelID;
  }
  if (offlinePushInfo.androidHuaWeiCategory) {
    obj.android_huawei_category = offlinePushInfo.androidHuaWeiCategory;
  }
  return obj;
}
